<template>
  <div>
    <b-navbar toggleable="lg" class="fixed-top navbar-dark " type="white" :class="{ 'bg-transparent': isTran, 'bg-dark':isPri }">


      <b-container>
        <b-navbar-brand :to="{ path:'/'}" @click="color=0">

          <picture >
            <source media="(min-width: 1200px)" srcset="/static/1200/1.png" >
            <source media="(min-width: 992px)" srcset="/static/320/1.png">
            <source media="(min-width: 768px)" srcset="/static/320/1.png">
            <source media="(min-width: 576px)" srcset="/static/320/1.png">
            <img src="/static/320/1.png" class="picture-width">
          </picture>
        </b-navbar-brand>
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-collapse is-nav id="nav_collapse">

          <b-navbar-nav class="ml-auto font-weight-bold top-list" >
            <!-- <b-nav-item href="/#/charttest">關於久億</b-nav-item> -->
            <b-nav-item   :to="{ path:'/aboutus'}">
            關於久億
            </b-nav-item>
            <b-nav-item   :to="{ path:'/news#1'}">
            最新消息
            </b-nav-item>
            <!-- <b-nav-item @click="color=3" :active="color===3" :to="{ name:'charttest', query: {tag: 2 ,page: 1 }}">
            產品型錄
            </b-nav-item> -->
          
                      
            <b-nav-item-dropdown  v-if="tags.length >= 1" text="產品型錄">
              
              <b-dropdown-item 
               v-for="tag in tags" :key="tag.name"
              :to="{ name: 'charttest_tag', params: { page: '1', tag: tag.id }}"
              >
              
              {{tag.name || ''}}
              </b-dropdown-item>

              <!--

              <b-dropdown-item  :to="{ path:'/charttest?tag=2&page=1'}" exact>{{tags[0]['name']}}</b-dropdown-item>
              <b-dropdown-item :to="{ path:'/charttest?tag=3&page=1'}" exact>{{tags[1]['name']}}</b-dropdown-item>
              <b-dropdown-item  :to="{ path:'/charttest?tag=4&page=1'}" exact>{{tags[2]['name']}}</b-dropdown-item>
              <b-dropdown-item :to="{ path:'/charttest?tag=5&page=1'}" exact>{{tags[3]['name']}}</b-dropdown-item>
              <b-dropdown-item  :to="{ path:'/charttest?tag=6&page=1'}" exact>{{tags[4]['name']}}</b-dropdown-item>
              <b-dropdown-item  :to="{ path:'/charttest?tag=39&page=1'}" exact>{{tags[5]['name']}}</b-dropdown-item>
              <b-dropdown-item  :to="{ path:'/charttest?tag=48&page=1'}" exact>{{tags[6]['name']}}</b-dropdown-item>-->
            </b-nav-item-dropdown>
            <b-nav-item   :to="{ path:'/QI'}">
            品質認證
            </b-nav-item>
            <b-nav-item   :to="{ path:'/contact'}">
            聯絡我們
            </b-nav-item>

          </b-navbar-nav>
        </b-collapse>
      </b-container>

    </b-navbar>
    <!-- navbar-1.vue -->

  </div>
</template>


<script>
import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
Vue.use(VueAxios, axios)
export default {
  data () {
    return {
      tags:[],
      isTran:true,
      isPri:false,
      color:-1,
    }
  },
  watch:{
    color(){
      if(this.color==3){
        document.querySelector('.b-nav-dropdown').children[0].style.color='rgb(185, 40 , 45)'
      }
      // else{
      //   document.querySelector('.b-nav-dropdown').children[0].style.color="white"
      // }
    }
  },
  methods:{
    getAllTag:function() {
      let vm = this;
      axios({
        method: "post",
        url: "https://iled.com.tw/bridging/api/v1/categories" 
      })
        .then((response) => {
          response.data.data.forEach(element => {
            
            this.tags.push(element);
            // console.log(vm.tags)
          });
          
        })
    },
    onScroll () {
      let scrolled = document.documentElement.scrollTop || document.body.scrollTop;
      let carheight= document.getElementById("carousel1").scrollHeight;
      let width = document.body.clientWidth;
　　　 
      if (scrolled >= carheight-50 || width<996 ) {
        this.isTran=false;
        this.isPri=true;
        
      } else {
        this.isTran=true;
        this.isPri=false;
        
        
      }
    }
  },
  created(){
  this.getAllTag();
  },
  mounted () {
    
  this.$nextTick(function () {
      this.onScroll();
      window.addEventListener('scroll', this.onScroll);
      
    });

  this.color=0;

  
  
},
}
</script>

<style lang="sass" scoped>
@import "~bootstrap/scss/bootstrap"
.b-nav-dropdown
  /deep/
    &>a
      color: white !important

.nav-link
  color: white !important
.dropdown-item
  text-shadow: none
.dropdown-item.active
  background-color: white !important
  color: rgb(185, 40 , 45) !important


li
  &>a.active
    color: rgb(185, 40 , 45) !important
.bg-dark
  background-color: rgba(19, 6, 6, .8) !important
.navbar-dark
  transition: .5s
.picture-width
  @include media-breakpoint-up(xl)
    width: 350px
  @include media-breakpoint-up(xs)
    width: 230px
.top-list
  @include media-breakpoint-up(xs)
    font-size: 20px
  @include media-breakpoint-up(xl)
    font-size: 25px
</style>












// WEBPACK FOOTER //
// src/components/NavBar.vue